/**
 * The tracking.js script loads the different tracking providers and handles the embed overlay
 */
import $ from 'jquery';
import { clickOnly, isIframe } from './utils';
const $overlay = $('.iframe-overlay');

// this google analytics plugin needs jquery: https://scrolldepth.parsnip.io/
window.jQuery = $;

const config = ARTICLE_CONFIG;

function init() {
  if (!isIframe()) {
    return loadTracking(config);
  }

  $('html').addClass('is-embed-mode');
  $('html').addClass('is-embed-overlay');

  $overlay.on('click', loadTracking);
  clickOnly('.iframe-overlay');
}

function loadTracking() {
  $('html').removeClass('is-embed-overlay');
  $overlay.remove();

  if (!config.tracking.enabled) {
    return false;
  }

  loadGAnalytics();
}

function loadGAnalytics() {
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-K52WG6');
}

export default {
  init
};
